<template>
    <Example
        class="example"
        :hasResponse="hasResponse"
        :requestInfo="requestInfo"
    >
        <template #title>
            Получение информации по ордеру (get-order-info)
        </template>
        <template #settings>
            <div class="example__row">
                <div class="example__col">
                    <ExampleSetting title="id ордера (orderId)">
                        <AtInput
                            size="small"
                            :status="orderIdStatus"
                            v-model="orderId"
                        />
                    </ExampleSetting>
                </div>
            </div>
            <div class="example__actions">
                <AtButton
                    type="primary"
                    size="large"
                    @click="makeRequest"
                >
                    Сделать запрос
                </AtButton>
                <AtButton
                    v-if="hasResponse"
                    size="large"
                    @click="clear"
                >
                    Очистить
                </AtButton>
            </div>
        </template>
        <template #response>{{ response }}</template>
    </Example>
</template>

<script>

import { mapGetters, mapActions } from "vuex";

import { exampleMixin } from "/public/mixins/example";

import Example from './Example';
import ExampleSetting from "./ExampleSetting";
import AtInput from 'at-ui/src/components/input';
import AtButton from "at-ui/src/components/button";

export default {
    name: 'GetOrderInfo',
    components: {
        Example,
        ExampleSetting,
        AtInput,
        AtButton,
    },
    mixins: [exampleMixin],
    data () {
        return {
            orderId: null,
            response: null,
        };
    },
    computed: {
        ...mapGetters('user', [
            'hasTestApiKeys',
        ]),
        hasResponse () {
            return Boolean(this.response);
        },
        orderIdStatus () {
            return !this.orderId ? 'error' : '';
        },
    },
    methods: {
        ...mapActions('app', [
            'apiRequest',
        ]),
        makeRequest () {
            const {
                hasTestApiKeys,
                orderId,
                apiRequest,
                setRequestInfo,
            } = this;

            if (!hasTestApiKeys) {
                return false;
            }

            apiRequest({
                method: 'get-order-info',
                data: {
                    orderId,
                },
            })
                .then(resp => {
                    const {
                        data: {
                            response,
                        },
                    } = resp;

                    this.response = response;
                    setRequestInfo(resp);
                })
                .catch(error => {
                    this.response = error.response.data;
                    setRequestInfo(error.response);
                });
        },
        clear () {
            this.orderId = null;
            this.response = null;
        },
    },
};

</script>